import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { SuiteAppSidebarItem } from "../../SharedSuite/Navbar/SuiteAppSidebarItem";
import { VideoAppType } from "../../../Types/VideoSuite-Types";
import { AccessTime } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { HistoryButton } from "../../../Layouts/SuiteHistoryLayout/Shared/HistoryButton";
import { useAppSelector } from "../../../store/hooks";

export interface VideoAppActiveInterface {
  type: number;
  title: string;
  icon: any;
}
interface VideoSuiteSidebarProps {
  activeItem: VideoAppType;
  setActiveItem: (item: string) => void;
  VideoSuitesApps: VideoAppType[];
}
const VideoSuiteSidebar = ({
  activeItem,
  setActiveItem,
  VideoSuitesApps,
}: VideoSuiteSidebarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isUserAuthenticated = useAppSelector((s) => s.User.IsAuthenticated);

  const handleSetActiveVideoApp = (appType: string) => {
    setActiveItem(appType);
    if (location.state?.activeVideoAppType) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  };

  return (
    <Box
      className={`app-suites-sidebar ${
        window.location.href.includes("video-suite") && "video-suite"
      }`}
      display="flex"
      alignItems="center"
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        className="video-suite-apps-container"
        sx={{
          width: "100%",
          flexGrow: 1,
        }}
      >
        {VideoSuitesApps?.map((app, i) => (
          <Box
            key={i}
            onClick={() => handleSetActiveVideoApp(app.name)}
            sx={{ width: "100%", my: 1 }}
          >
            <SuiteAppSidebarItem
              title={app.name}
              icon={app.icon}
              isActive={activeItem.name === app.name}
            />
          </Box>
        ))}
      </Box>
      {isUserAuthenticated&&(<HistoryButton navigateRoute="/suites/history/video" />)}
    </Box>
  );
};

export default VideoSuiteSidebar;
